export default __webpack_public_path__ + "static/media/carton.9c67e4d7.png";